// config.js

// サイト全体で共通して使われる可能性のある値を定数として定義
const SITE_URL = 'https://support.adap.kke.co.jp';
const LOGO_IMAGE_PATH = '/images/ADAP-Head.png'; // ロゴ画像のパス
const DEFAULT_PATH_PREFIX = '/';

const config = {
  // Gatsby固有の設定
  gatsby: {
    pathPrefix: DEFAULT_PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null, // Google Analytics ID (現在は未使用)
    trailingSlash: false,
  },

  // サイト全体のメタデータ (gatsby-config.js や各コンポーネントから参照される)
  siteMetadata: {
    title: 'ADAPヘルプサイト',          // SEOタイトル、ウィンドウタイトルのフォールバック等
    description: 'ADAPに関する疑問を解消', // SEO用の説明文
    ogImage: null,                     // Open Graph 用の画像パス
    favicon: LOGO_IMAGE_PATH,          // ファビコンのパス

    // サイトのブランド情報
    siteName: 'ADAPヘルプサイト',      // サイト名
    logo: {
      src: LOGO_IMAGE_PATH,
      alt: 'ADAPヘルプサイト ロゴ',     // ロゴのaltテキスト
      link: DEFAULT_PATH_PREFIX,     // ロゴクリック時のリンク先
    },
    headerTitle: 'ADAPヘルプ',         // ヘッダーに表示されるテキストタイトル
    // 例: もしヘッダータイトル自体を特定の外部リンクにしたい場合
    // headerTitleLink: 'https://www.kke.co.jp/',
  },

  // ヘッダー固有の表示設定
  header: {
    // ロゴやタイトルは基本的に siteMetadata から取得することを推奨
    // このセクションは、ヘッダー特有の追加リンクや機能のために使用
    navLinks: [
      // { text: 'KKE Home', link: 'https://www.kke.co.jp/', external: true },
    ], // ヘッダーナビゲーションリンク (現在は空)
    search: {
      enabled: false, // 検索機能の有効/無効
      indexName: '',  // Algoliaなどのインデックス名 (現在は未使用)
    },
    // 以前の header.title にあったHTML文字列は、siteMetadata.headerTitle (プレーンテキスト) を
    // Header.js が使用しているため削除。もしHTML構造が必要な場合はコンポーネント側で構築。
  },

  // サイドバー固有の設定
  sidebar: {
    forcedNavOrder: [
      '/introduction',
      '/codeblock',
    ],
    collapsedNav: [
      '/codeblock',
    ],
    externalLinks: [ // 'links' から 'externalLinks' に名称変更 (明確化のため)
      // { text: '構造計画研究所', link: 'https://www.kke.co.jp/' },
    ], // サイドバー内の外部リンク (現在は空)
    frontLine: false, // テーマ由来のスタイル設定 (必要であれば維持)
    ignoreIndex: true, // サイドバー生成時にindexページを無視するか
  },
};

module.exports = config;